import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { CssBaseline, Grid, IconButton, InputBase, Paper } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';

const useStyles = makeStyles((theme) => ({
    root: {
        marginTop: theme.spacing(1),
        padding: '2px 4px',
        display: 'flex',
        alignItems: 'center',
        width: 200,
        borderStyle: 'none',
        borderRadius: 0,
        height: '30px',
    },
    input: {
        marginLeft: theme.spacing(1),
        flex: 1,
        color: 'rgb(0,0,0)',
        height: '20px',
    },
    iconButton: {
        padding: 10,
    },
    errorMsg: {
        marginLeft: '10px',
        color: '#fd5f5f',
        fontSize: '11px',
    }
}));

function SearchBox(props) {
    const classes = useStyles();
    const { placeholder, searchQuery, onChange, clearField } = props;
    //console.log(onChange);
    //console.log(props);
    return (
        <div>
            <Grid item xs={1}>
                <CssBaseline />
                <Paper component="form" className={classes.root}>
                    <InputBase
                        className={classes.input}
                        placeholder={placeholder}
                        inputProps={{ 'aria-label': 'Search Client' }}
                        id="Search"
                        autoFocus
                        autoComplete="off"
                        onKeyPress={e => {
                            if (e.key === 'Enter') e.preventDefault();
                        }}
                        onChange={(e) => onChange(e.target.value)}
                        value={searchQuery}
                        endAdornment={!searchQuery ? <SearchIcon /> : <HighlightOffIcon style={{ color: 'grey !important', cursor: 'pointer' }} onClick={() => clearField()} />}
                    />
                    <IconButton
                        type="button"
                        className={classes.iconButton}
                        aria-label="search"
                        onClick={(e) => onChange(searchQuery)}>
                        <SearchIcon />
                    </IconButton>
                </Paper>
            </Grid>
            {searchQuery && searchQuery.length < 3 ?
                <div className={classes.errorMsg}>Please enter more than 2 characters
                </div> : null}
        </div>
    );
}
export default SearchBox;
